import { getAnalytics, logEvent } from 'firebase/analytics';
import { useNavigate } from "react-router-dom";




const DownloadPlayStoreLink = ({ small }) => {
    const analytics = getAnalytics();
    const navigate = useNavigate();

    const onClick = () => {
        logEvent(analytics, 'donwload_playstore_click');
        navigate("/download_android");
    }

    return (
        <button onClick={onClick}>
            <div
                className='downloadAppButton blurBackground'
                style={small ? {
                    width: '34px',
                    height: '34px',
                    padding: '0px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } : undefined}
            >
                <img
                    src="/icons/android.png"
                    alt="android"
                    style={{ verticalAlign: 'middle', height: small ? '22px' : '60px', padding: small ? '0px' : '4px' }}
                />
            </div>
        </button>
    );
};

export default DownloadPlayStoreLink;
